<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      code: string;
      label: string;
    }
  "
>
import type {
  EntitiesAggregation,
  AggregationFilterEntity,
  PriceAggregation,
  MaxAggregation,
} from "@shopware-pwa/types";
import { computed, ref } from "vue";

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: {
    [key: string]:
      | EntitiesAggregation<AggregationFilterEntity>
      | PriceAggregation
      | MaxAggregation
      | number;
    rating: number;
  };
}>();
const isHoverActive = ref(false);
const hoveredIndex = ref(0);
const displayedScore = computed(() =>
  isHoverActive.value ? hoveredIndex.value : props.selectedFilters?.rating || 0,
);

const hoverRating = (key: number) => {
  hoveredIndex.value = key;
  isHoverActive.value = true;
};
const onChangeRating = () => {
  const newValue =
    props.selectedFilters?.rating !== hoveredIndex.value
      ? hoveredIndex.value
      : undefined;
  emits("select-value", { code: props.filter?.code, value: newValue });
};

const isFilterVisible = ref<boolean>(false);
const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};

const filterBody = ref(null);
onClickOutside(filterBody, () => (isFilterVisible.value = false));
</script>

<template>
  <div class="filter-wrap">
    <h3 class="filter-head">
      <button
          type="button"
          @click="toggle"
      >
        <span>{{ filter.label}}</span>
        <span class="ml-6 flex items-center">
          <i :class="[
              !isFilterVisible
                ? 'i-carbon-chevron-down'
                : 'i-carbon-chevron-up',
            ]"
          />
        </span>
      </button>
    </h3>
    <transition name="fade" mode="out-in">
      <div v-show="isFilterVisible" class="filter-body" ref="filterBody">
        <div class="space-y-6 mt-4">
          <div class="flex">
            <div
                v-for="i in 5"
                :key="i"
                class="h-6 w-6 c-yellow-500"
                :class="{
                'i-carbon-star-filled': displayedScore >= i,
                'i-carbon-star': displayedScore < i,
              }"
                @mouseleave="isHoverActive = false"
                @click="onChangeRating()"
                @mouseover="hoverRating(i)"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
